var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXTwitter = function SvgXTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "-8 -8 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#X-Twitter_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.429 0A3.437 3.437 0 0 0 0 3.439v17.195a3.437 3.437 0 0 0 3.429 3.44H20.57A3.437 3.437 0 0 0 24 20.633V3.44A3.437 3.437 0 0 0 20.571 0zm15.916 4.514-5.561 6.373 6.541 8.673h-5.121l-4.008-5.261-4.59 5.26H4.06l5.946-6.818-6.273-8.227h5.25l3.627 4.809 4.189-4.81zm-2.025 13.52L8.218 5.958H6.702l9.203 12.074h1.415"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "X-Twitter_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgXTwitter;